import { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faCaretDown,
    faCaretUp,
} from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"
import { TriggerWrapper, NavWrapper, NavCollapsible } from "./AdvancedSettings.style"
import { Button } from "../../App.styles"
import ContentTab from '../ContentTab'

const AdvancedSettings = (props) => {
    const { t } = useTranslation()
    const { 
        tabs = [],
        title = t('Advanced Settings'),
        subtitle = '',
    } = props
    const [showContent, setShowContent] = useState(false)

    return (
        <NavWrapper className="mt-4">
            <TriggerWrapper>
                <span className="d-inline-block text-warning">{subtitle}</span>
                <Button className="btn--flat" color="info" onClick={() => setShowContent(!showContent)}>
                    {title} <FontAwesomeIcon icon={showContent ? faCaretUp : faCaretDown} />
                </Button>
            </TriggerWrapper>
            <NavCollapsible show={showContent}>
                <ContentTab
                    tabs={tabs}
                />
            </NavCollapsible>
        </NavWrapper>
    )
}

export default AdvancedSettings
